<template>
  <div class="sp-template">
    <div class="h-title">按批次统计信息</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="开始日期">
              <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
            </el-form-item>  
            <el-form-item>
              <el-input style="width: 300px;" v-model.lazy="queryForm.search" title="航空公司、代理公司、航空单号" placeholder="航空公司、代理公司、航空单号、柜号" clearable ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="批次号" >
              <el-input v-model="batchIdTextArea" type="textarea" placeholder="多个批次号用回车分割" clearable></el-input>
            </el-form-item>

            <el-form-item label="类型">
              <el-select class="width-inline" size="small" clearable placeholder="选择类型" v-model="queryForm.type">
                    <el-option v-for="(d,i) in batchTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select> 
            </el-form-item>
            <el-form-item label="成本已完成">
              <el-select class="width-inline" size="small" clearable placeholder="选择类型" v-model="queryForm.costDone">
                    <el-option label="是" value="true"></el-option>
                    <el-option label="否" value="false"></el-option>
                </el-select> 
            </el-form-item>
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(80401)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(80401)" size="small" @click="reset()">清 空</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.channelType" @tab-click="searchTask">
          <el-tab-pane v-if="in_configs(80404)" label="空运" name="AIR_SHIPPING"></el-tab-pane>
          <el-tab-pane v-if="in_configs(80405)" label="海运" name="SEA_SHIPPING"></el-tab-pane>
          <el-tab-pane v-if="in_configs(80406)" label="铁运" name="RAILWAY_SHIPPING"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(80402)" size="small" @click="exportExcel(1)">导出当前页</el-button>
          <el-button v-if="in_configs(80403)" size="small" @click="exportExcel(2)">导出全部</el-button>
          <el-button v-if="in_configs(80407)" size="small" @click="batchCostChargeExport">导出批次成本费用</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="batchId" label="批次号" width="123"></el-table-column>
        <el-table-column label="类型" width="80">
          <template slot-scope="scope">
            {{batchTypeMap[showBatchAttribute(scope.row,"type")]}}
          </template>
        </el-table-column>
        <el-table-column v-if="queryForm.channelType == 'AIR_SHIPPING'" label="航空公司" width="120">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"airlines")}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="queryForm.channelType == 'SEA_SHIPPING'" label="船公司" width="120">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"shipping_company")}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="queryForm.channelType == 'RAILWAY_SHIPPING'" label="铁路公司" width="120">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"railway_companies")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="代理公司" width="120">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"agency_company")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="航空单号" width="120" v-if="queryForm.channelType == 'AIR_SHIPPING'">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"air_waybill")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="柜号" width="120" v-if="queryForm.channelType == 'SEA_SHIPPING'">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"air_waybill")}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="订单量" width="100"></el-table-column>
        <el-table-column prop="billedWeight" label="计费重(KG)" width="100"></el-table-column>
        <el-table-column prop="packageQty" label="包裹数量" width="100"></el-table-column>
        <el-table-column prop="totalWeight" label="总重量(KG)" width="100"></el-table-column>
        <el-table-column prop="amount" label="销售额(元)"  width="100"></el-table-column>
        <el-table-column prop="estimateAmount" label="成本总金额(元)" width="100"></el-table-column>
        <el-table-column label="财务成本总金额(元)" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.costAmount && scope.row.costAmount > 0" @click="showBatchCostDetail(scope.row.batchId)" size="medium" type="text" >
              {{scope.row.costAmount}}
            </el-button>
            <span v-else >{{scope.row.costAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="profit" label="利润(元)"  width="100"></el-table-column>
        <el-table-column label="成本已完成" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.costDone ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" >
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.createDate), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
      
      <el-table :data="tongjiData" stripe border style="width: 100%" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column label="" width="123">
          <template slot-scope="scope">
            合计：
          </template>
        </el-table-column>
        <el-table-column label="" width="80">
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column label="" width="120">
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column label="" width="120">
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column label=""  width="120" v-if="queryForm.channelType == 'AIR_SHIPPING' || queryForm.channelType == 'SEA_SHIPPING'" >
          <template slot-scope="scope">
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="" width="100"></el-table-column>
        <el-table-column prop="billedWeight" label="" width="100"></el-table-column>
        <el-table-column prop="packageQty" label="" width="100"></el-table-column>
        <el-table-column prop="totalWeight" label="" width="100"></el-table-column>
        <el-table-column prop="amount" label=""  width="100"></el-table-column>
        <el-table-column prop="estimateAmount" label=""  width="100"></el-table-column>
        <el-table-column prop="costAmount" label=""  width="100"></el-table-column>
        <el-table-column prop="profit" label=""  width="100"></el-table-column>
        <el-table-column label="" >
          <template slot-scope="scope">
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
    <form action="" method="get" target="_blank" id="myform"></form>

    <!-- Form -->
    <el-dialog title="完成" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="提货箱数">
          <el-input v-model="cartonQty" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDone()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="费用明细" class="common-select__dialog" :visible.sync="dialogVisible" width="700px">
      <el-table :data="batchCostData" border style="width: 100%;" max-height="800" ref="table" class="order-charge__table" >
        <el-table-column prop="serviceType" label="费用类型"></el-table-column>
        <el-table-column prop="totalAmount" label="金额"></el-table-column>
        <el-table-column label="付款状态" >
          <template slot-scope="scope">
            {{settlementStatusMap[scope.row.settlementStatus]}}
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>
  </div>

</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      dialogVisible: false,
      batchCostData: [],
      batchTypeList: [
        {
          id: "selfsupport",
          name: "自营"
        },
        {
          id: "agency",
          name: "代理"
        }
      ],
      batchTypeMap: {
        selfsupport: "自营",
        agency: "代理"
      },
      settlementStatusMap:{'NO_SETTLEMENT':'未付款','PARTIAL_SETTLEMENT':'部分付款','HAS_SETTLEMENT':'已付款'},
      queryForm: {
        search: "",
        channelType: "AIR_SHIPPING",
        batchIds: [],
        startDate: "",
        endDate: "",
        type: "",
        export: 0,
        pageSize: 10,
        currentPage: 1,
        costDone:null
      },
      batchIdTextArea: "",
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},

      orderCount: 0,
      billedWeight: 0,
      packageQty: 0,
      totalWeight: 0,
      amount: 0,
      costAmount: 0,
      profit: 0,
      tongjiData: [],

      status: "未处理",
      searchData: {
        //搜索数据
        statu: "",
        product: "",
        number: "",
        startDate: "",
        endDate: ""
      },
      tableData: [],
      drivers: [],
      vehicles: [],
      driversMap: {},
      vehiclesMap: {},
      dialogFormVisible: false,
      cartonQty: 0,
      orderId: "",
      timeTypes: [
        { id: "charge", name: "扣费时间" },
        { id: "deliver", name: "发货时间" }
      ],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      total: 0
    };
  },
  created() {
    setTimeout(() => {
      var _this = this;
      let urlArray = [this.findAllCustomerName(), this.findAllChannle()];
      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, channelData) {
          _this.initCustomerData(customerData);
          _this.initChannelData(channelData);

          _this.queryForm.startDate = _this.getLastMonth();
          _this.queryForm.endDate = _this.getTheMonth();
          _this.queryOrder();
        })
      );
    }, 800);
  },
  computed: {
    configs() {
      return JSON.parse(sessionStorage.configs);
    }
  },
  methods: {
    getLastMonth() {
      var nowdate = new Date();
      nowdate.setDate(1);
      nowdate.setMonth(nowdate.getMonth() - 1);
      return this.formatDate(nowdate, "yyyy-MM-dd");
    },
    getTheMonth() {
      var nowdate = new Date();
      nowdate.setDate(0);
      return this.formatDate(nowdate, "yyyy-MM-dd");
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all'
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll'
      );
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //查询客户
    findByCustomerName() {
      let _this = this;
      this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data;
            if (_this.customers.length > 0) {
              _this.customers.forEach(c => {
                _this.customerMaps[c.id] = c.name;
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //搜索
    searchTask() {
      this.queryForm.currentPage = 1;
      this.queryOrder();
    },
    reset() {
      this.queryForm = {
        search: "",
        channelType: "AIR_SHIPPING",
        batchIds: [],
        startDate: "",
        endDate: "",
        export: 0,
        pageSize: 10,
        currentPage: 1
      };
      this.batchIdTextArea = "";
      this.searchTask();
    },
    //编辑
    handleEdit(index, row) {
      row.assign = false;
    },
    //分页
    handleSizeChange(val) {
      this.queryForm.currentPage = 1;
      this.queryForm.pageSize = val;
      this.queryOrder();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.queryOrder();
    },
    queryOrder() {
      let _this = this;
      _this.queryForm.export = 0;

      _this.queryForm.batchIds = [];
      _this.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          _this.queryForm.batchIds.push(d);
        }
      });

      this.$request1
        .post(
          '/report/batch',
          _this.queryForm,
          {
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(function(response) {
          if (!response.data.success) {
            _this.$message.error(response.data.message);
            return;
          }
          if(response.data.data == null) {
            _this.tableData = [];
            _this.total = 0;            
            return;
          }

          _this.total = response.data.total;
          if (_this.total == 0) {
            return;
          }
          _this.tableData = response.data.data.list;

          _this.orderCount = response.data.data.orderCount;
          _this.billedWeight = response.data.data.billedWeight;
          _this.packageQty = response.data.data.packageQty;
          _this.totalWeight = response.data.data.totalWeight;
          _this.amount = response.data.data.amount;
          _this.costAmount = response.data.data.costAmount;
          _this.estimateAmount = response.data.data.estimateAmount;
          _this.profit = response.data.data.profit;
          _this.tongjiData = [
            {
              orderCount: _this.orderCount,
              billedWeight: _this.billedWeight,
              packageQty: _this.packageQty,
              totalWeight: _this.totalWeight,
              amount: _this.amount,
              costAmount: _this.costAmount,
              estimateAmount: _this.estimateAmount,
              profit: _this.profit
            }
          ];
        })
        .catch(function(error) {});
    },
    exportExcel(val) {

      let _this = this;
      _this.queryForm.export = val;

      this.$request1({
          url: '/report/batch',
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          _this.queryForm.export = 0
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `batch_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })

      // let _this = this;
      // _this.queryForm.export = val;
      // var url = tmsSpringUrl + '/report/batch';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // for (var key in _this.queryForm) {
      //   if (key != "batchIds") {
      //     fhtml +=
      //       '<input type="hidden" name="' +
      //       key +
      //       '" value="' +
      //       (_this.queryForm[key] == null ? "" : _this.queryForm[key]) +
      //       '" />';
      //   }
      // }
      // if (this.queryForm.batchIds.length > 0) {
      //   this.queryForm.batchIds.forEach(a => {
      //     fhtml +=
      //       '<input type="hidden" name="batchIds[]" value="' + a + '" />';
      //   });
      // }

      // fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
        
      // form.innerHTML = fhtml;
      // form.submit();
    },
    showBatchAttribute(row, key) {
      let _this = this;
      let _val = "";
      if (row.batchAttributesValues && row.batchAttributesValues.length > 0) {
        row.batchAttributesValues.forEach((d, i) => {
          if (d.attributeKey == key) {
            _val = d.attributeValue;
          }
        });
      }
      return _val;
    },
    showBatchCostDetail(batchId) {
      this.$request1({
        method: 'GET',
        url: '/report/batch-cost-detail',
        params: {
          batchId: batchId
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success) {
            this.batchCostData = response.data.data;
            this.dialogVisible = true;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },
    batchCostChargeExport() {
      this.queryForm.batchIds = [];
      this.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          this.queryForm.batchIds.push(d);
        }
      });

      this.$request1({
        method: 'POST',
        url: '/report/download/batch-cost',
        headers: { "content-type": "application/json" },
        responseType: "json",
        data: this.queryForm
      }).then(res => {
        if (!res.data.success) {
          this.$notify.error({
            title: "错误消息",
            message: res.data.message
          });
          return;
        }
        var byteCharacters = atob(res.data.data);

        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        let blob = new Blob([byteArray], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        a.download = "batch_cost_charge.xlsx";
        a.click();
      });
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2
              ? "/u661f/u671f"
              : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
//function formatDate(date,fmt){if(!date){return""}var o={"M+":date.getMonth()+1,"d+":date.getDate(),"h+":date.getHours()%12==0?12:date.getHours()%12,"H+":date.getHours(),"m+":date.getMinutes(),"s+":date.getSeconds(),"q+":Math.floor((date.getMonth()+3)/3),"S":date.getMilliseconds()};var week={"0":"/u65e5","1":"/u4e00","2":"/u4e8c","3":"/u4e09","4":"/u56db","5":"/u4e94","6":"/u516d"};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length))}if(/(E+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,((RegExp.$1.length>1)?(RegExp.$1.length>2?"/u661f/u671f":"/u5468"):"")+week[date.getDay()+""])}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,(RegExp.$1.length==1)?(o[k]):(("00"+o[k]).substr((""+o[k]).length)))}}return fmt};
</script>

<style lang="scss" scoped>
.el-card__header .el-form .el-input {
  width: 205px;
}
</style>


// WEBPACK FOOTER //
// src/views/report/batch.vue